import type { Uuid } from '@sibe/utilities/common';
import { HsEngineObject } from '../../engine-new/objects/common/engine-object.class';
import type { HsGeometry } from '../../graphic-engine-new/geometry/geometry.interface';
import type { HsMaterial } from '../materials/material.class';

/**
 * Handles s graphic object.
 */
export class HsGraphicObject extends HsEngineObject {
  public visible: boolean = true;

  public query: WebGLQuery | null = null;
  public queryInProgress: boolean = false;
  public occluded: boolean = false;

  constructor(uuid: Uuid, name: string, public geometry: HsGeometry, public material: HsMaterial) {
    super(uuid, name);
  }

  public updateBoundingSphere(): void {
    this.boundingBox.copy(this.geometry.boundingBox).applyMatrix4(this.worldMatrix);
    this.boundingSphere.setFromBox(this.boundingBox.min, this.boundingBox.max);
  }
}
